import { helper } from '@ember/component/helper';

export function gt([a, b]: [number, number]): boolean {
  return a > b;
}

export default helper(gt);
